export default __webpack_public_path__ + "static/media/big-data.96732bca.svg";